import { TanquerayBack } from "@/components/shared/Tanqueray/TanquerayBack";
import { TQuizTanquerayProps } from "../type";
import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { DdpImage } from "@/components/shared/DdpImage";
import { DdpCta } from "@/components/shared/DdpCta";
import { IconCricleSelected } from "@/components/icon/tanqueray";
import { useEffect } from "react";
import { tracking } from "@/shared/tracking";
import { UtilPrevBack } from "@/shared/utils";
export function QuizTanqueray(props: TQuizTanquerayProps) {
    const { localeData: {
        topLabelTanqueray
    } } = useCmsStore()!
    const { titleDreamVibe, choosePromptLabel, continueCTA, dreamVibe, titleFood } = props
    const { setAnswer, answer, resetAnswer } = useAppStore()
    return <div className="page-tanqueray-quiz">
        <div className="top-wrapper">
            <TanquerayBack onClick={() => {
                if (answer.atmosphere) {
                    resetAnswer()
                } else {
                    UtilPrevBack().then((res) => {
                        if (res) {
                            window.history.back()
                        }
                    })
                }
            }} />
            <div className="top-label">{topLabelTanqueray}</div>
            <div className="title">{!answer.atmosphere ? titleDreamVibe : titleFood}</div>
            <div className="cta-wrapper">
                <div className="choose-prompt-label">{choosePromptLabel}</div>
                <DdpCta className="btn-next black nohover" disabled={answer.recipes.length < 3} cta={continueCTA} />
            </div>
        </div>
        <div className="bottom-wrapper">

            {!answer.atmosphere &&
                <div className="vibe-container">
                    {dreamVibe.map((item, index) => (
                        <div key={index} className="dream-vibe-item" onClick={() => {
                            setAnswer({
                                atmosphere: item.atmosphereID,
                                atmosphereName: item.atmosphereName,
                                recipes: [],
                            })
                            tracking({
                                "event": "custom_event",
                                "event_name": "quiz_step",
                                "step": "question 2"
                            })
                        }}>
                            <div className="dream-vibe-media-wrapper">
                                <DdpImage image={item.backgroundImage[0]} />
                            </div>

                            <div className="dream-vibe-content">
                                <div className="dream-vibe-title">{item.atmosphereName}</div>
                                <div className="dream-vibe-desc" dangerouslySetInnerHTML={{ __html: item.atmosphereDescription }} />
                            </div>
                        </div>
                    ))}
                </div>
            }
            {
                answer.atmosphere &&
                <div className="food-container">
                    <div className="food-list">
                        {
                            answer.atmosphere && dreamVibe.find((item) => item.atmosphereID === answer.atmosphere)?.foodList.map((item) => {
                                return <div className={`food-item ${answer?.recipes.includes(item.foodID) ? 'selected' : ''}`} key={item.foodID} onClick={() => {
                                    if (answer.recipes.includes(item.foodID)) {
                                        setAnswer({
                                            ...answer,
                                            recipes: [...answer.recipes.filter(foodID => foodID !== item.foodID)],
                                        })
                                    } else {
                                        setAnswer({
                                            ...answer,
                                            recipes: [...answer.recipes, item.foodID],
                                        })
                                    }
                                }} >
                                    <div className="food-media-wrapper">
                                        <DdpImage className="food-img" image={item.backgroundImage} />
                                    </div>
                                    <div className="food-content-wrapper">
                                        <div className="food-text">{item.foodName}</div>
                                        <IconCricleSelected className="selected-icon" />
                                    </div>

                                </div>
                            })
                        }
                    </div>
                    <div className="cta-wrapper">
                        <div className="choose-prompt-label">{choosePromptLabel}</div>
                        <DdpCta className="btn-next black nohover" disabled={answer.recipes.length < 3} cta={continueCTA} />
                    </div>
                </div>
            }

        </div>
    </div>
}